import * as dap from "./index.js";

Object.assign(globalThis, { divviup: { dap } });
// const task = new divviup.dap.Task({...});
